<template>
  <section class="form__item__input">
    <vue-timepicker :id="id" v-model="value" @change="(data)=>{ onChangeTime(data) }" format="HH:mm:ss"></vue-timepicker>
  </section>
</template>

<script>
import VueTimepicker from 'vue2-timepicker'
import moment from 'moment'

export default {
  name: 'Timepicker',
  components: {
    VueTimepicker
  },
  props: ['settings', 'defaultValue', 'id'],
  methods: {
    onChangeTime(newVal){
      let { HH, mm, ss } = newVal.data;
      this.value = { HH, mm, ss }
      this.$emit('input', this.value);
    }
  },
  data(){
    return {
      value: this.defaultValue || null
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/configurator/Timepicker.vue